import React from 'react'
import Box from '@material-ui/core/Box'
import {makeStyles} from '@material-ui/core/styles'
import {Backdrop, Card, CardContent} from '@material-ui/core'
import LoginButton from './LoginButton'

const useStyles = makeStyles(theme => ({
  card: {
    position: 'relative',
    overflow: 'auto'
  },
  backdrop: {
    position: 'absolute',
    zIndex: theme.zIndex.modal + 1
  }
}))

export default function LoginPopup() {
  const classes = useStyles()

  return (
    <Backdrop open={true} className={classes.backdrop}>
      <Card variant="outlined" elevation={4} className={classes.card}>
        <CardContent>
          <Box justifyContent="space-around">
            <Box>Your session in ended.</Box>
          </Box>
          <LoginButton />
        </CardContent>
      </Card>
    </Backdrop>
  )
}
